import { render } from "./sku-detail.vue?vue&type=template&id=576b43fd&scoped=true&ts=true"
import script from "./sku-detail.vue?vue&type=script&lang=ts"
export * from "./sku-detail.vue?vue&type=script&lang=ts"

import "./sku-detail.vue?vue&type=style&index=0&id=576b43fd&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576b43fd"]])

export default __exports__